export { default as PageNotFoundIllustration } from './PageNotFoundIllustration';
